import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as o, useEffect as i } from "react";

var s = function s(t) {
  var _o = o(""),
      _o2 = _slicedToArray(_o, 2),
      e = _o2[0],
      n = _o2[1];

  return i(function () {
    n(t ? "hg-primarynav--with-flyout-open" : "");
  }, [t]), e;
};

export { s as useFlyoutAnimation };